import React, { useState } from 'react'
import Search from './search'
import * as txStyles from '../styles/transactions.module.scss'
import Details from './details'

import { Row, Col } from 'react-bootstrap'

const Transactions = (props) => {
  const [inFetch, setInFetch] = useState(null)
  const [success, setSuccess] = useState(null)
  const [errorMsg, setErrorMsg] = useState(null)
  const [details, setDetails] = useState(null)
  const [txVin, setTxVin] = useState(null)
  const [txVout, setTxVout] = useState(null)

  const { bchjs } = props
  const onSearch = async (txid) => {
    try {
      resetStates()
      setInFetch(true)
      const result = await bchjs.Transaction.get(txid)
      const data = result.txData
      const details = parseTxData(data)
      setDetails(details)

      const txVin = parseVin(data)
      setTxVin(txVin)

      const txVout = parseVout(data)
      setTxVout(txVout)

      setInFetch(false)
      setSuccess(true)
    } catch (error) {
      setInFetch(false)
      setSuccess(false)
      handleError(error)
      console.warn('Error in transactions/onSearch()', error)
    }
  }
  const handleError = (error) => {
    try {
      let errMsg = 'Error'
      if (error.message) {
        errMsg = error.message
      } else if (error.error && error.error.error) {
        errMsg = error.error.error
      } else if (error.error) {
        errMsg = error.error
      }
      setErrorMsg(errMsg)
    } catch (error) {
      console.warn(error)
    }
  }

  const resetStates = () => {
    setErrorMsg(null)
    setSuccess(false)
    setDetails(null)
    setTxVin(null)
    setTxVout(null)
  }
  const parseTxData = (data) => {
    try {
      const details = {}
      details.txid = data.txid
      details.isValidSlp = data.isValidSlp
      details.blockheight = data.blockheight
      details.confirmations = data.confirmations

      if (data.isValidSlp) {
        details.tokenTxType = data.tokenTxType
        details.tokenId = data.tokenId
        details.tokenType = data.tokenType
        details.tokenTicker = data.tokenTicker
        details.tokenName = data.tokenName
        details.tokenDecimals = data.tokenDecimals
        details.tokenUri = data.tokenUri
        details.tokenDocHash = data.tokenDocHash
      }
      return details
    } catch (error) {
      console.warn(error)
    }
  }
  const parseVin = (data) => {
    try {
      const { vin } = data
      const txVin = []
      for (let i = 0; i < vin.length; i++) {
        const _vin = vin[i]
        const obj = {}
        obj.txid = _vin.txid
        obj.vout = _vin.vout
        obj.address = _vin.address
        obj.txid = _vin.txid
        if (data.isValidSlp) {
          obj.tokenQty = _vin.tokenQty
        }

        txVin.push(obj)
      }

      return txVin
    } catch (error) {
      console.warn(error)
    }
  }

  const parseVout = (data) => {
    try {
      const { vout } = data
      const txVout = []
      for (let i = 0; i < vout.length; i++) {
        const _vout = vout[i]
        const obj = {}
        console.log(_vout.scriptPubKey)
        console.log(_vout.scriptPubKey.addresses)

        obj.value = _vout.value
        obj.vout = _vout.n
        obj.tokenQtyStr = _vout.tokenQtyStr

        if (_vout.scriptPubKey && _vout.scriptPubKey.addresses) { obj.addresses = _vout.scriptPubKey.addresses }
        txVout.push(obj)
      }

      return txVout
    } catch (error) {
      console.warn(error)
    }
  }
  return (
    <main className={txStyles.wrapper}>
      <h1 className={txStyles.title}>TRANSACTIONS</h1>
      <Search onSearch={onSearch} txid={props.txid} />
      {inFetch && <div className={txStyles.loader} />}
      <Row className={txStyles.wrapper}>
        <Col xs={9} md={1} />
        <Col xs={12} md={10}>
          {/*  Transaction Details */}
          {details && success &&
            <>
              <h3 className={txStyles.cardTitle}>Transaction Details.</h3>
              <Details data={details} />
            </>}

          <Row className={txStyles.wrapper}>
            <Col xs={9} md={6}>
              {/* Inputs */}

              {txVin &&
                <>
                  <h3 className={txStyles.cardTitle}>Inputs.</h3>
                  {
                        txVin.map((val, i) => {
                          return <Details key={`vin-${i}`} id={`vin-${i}`} data={val} />
                        })
                      }
                </>}
            </Col>
            <Col xs={9} md={6}>
              {/* Outputs */}
              {txVout &&
                <>
                  <h3 className={txStyles.cardTitle}>Outputs.</h3>
                  {
                        txVout.map((val, i) => {
                          return <Details key={`vout-${i}`} id={`vout-${i}`} data={val} />
                        })
                      }
                </>}
            </Col>
          </Row>
        </Col>
        <Col xs={9} md={1} />

      </Row>
      {
        errorMsg &&
          <p className={txStyles.errorColor}>
            {errorMsg}
          </p>
      }
    </main>
  )
}

export default Transactions
